import React, { useState, useEffect, useRef, useCallback } from "react";
import { FaTimes, FaChevronLeft, FaChevronRight } from "react-icons/fa";
import ReactModal from "react-modal";
import "../styles/Home.css";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import video1 from "../13/MSP.mp4";
import video2 from "../16/MSP.mp4";
import video3 from "../16/MSP3.mp4";
import video4 from "../16/MSP4.mp4";
import video5 from "../16/MSP5.mp4";
import video6 from "../16/MSP6.mp4";
import video7 from "../16/MSP7.mp4";
import video8 from "../16/MSP8.mp4";
import video9 from "../16/MSP9.mp4";
import video10 from "../16/MSP10.mp4";
import {
  FaMapMarkerAlt,
  FaCalendarAlt,
  FaClock,
  FaMicrophone,
  FaPlay,
  FaBookOpen,
  FaQuoteLeft,
  FaExpand
} from "react-icons/fa";

/* ---------- Scroll-reveal wrapper (no external libs) ---------- */
const Reveal = ({ children, className = "", delay = 0, as: Tag = "div" }) => {
  const ref = useRef(null);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const node = ref.current;
    if (!node) return;

    const prefersReducedMotion = window.matchMedia(
      "(prefers-reduced-motion: reduce)"
    ).matches;

    if (prefersReducedMotion) {
      setVisible(true);
      return;
    }

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setVisible(true);
          observer.unobserve(node);
        }
      },
      { threshold: 0.15, rootMargin: "0px 0px -60px 0px" }
    );

    observer.observe(node);
    return () => observer.disconnect();
  }, []);

  return (
    <Tag
      ref={ref}
      className={`reveal ${visible ? "reveal-visible" : ""} ${className}`}
      style={{ transitionDelay: visible ? `${delay}ms` : "0ms" }}
    >
      {children}
    </Tag>
  );
};

const Home = () => {
  const [isMobile, setIsMobile] = useState(false);
  const [videoPlaying, setVideoPlaying] = useState(false);
  const [lightboxIndex, setLightboxIndex] = useState(null);

  useEffect(() => {
    const checkIfMobile = () => setIsMobile(window.innerWidth <= 768);
    checkIfMobile();
    window.addEventListener("resize", checkIfMobile);
    return () => window.removeEventListener("resize", checkIfMobile);
  }, []);

  const handlePlayVideo = () => {
    setVideoPlaying(true);
    const video = document.querySelector(".hero-video");
    if (video) video.play();
  };

  const carouselImages = [
    { id: 1, src: "/carousel1/1.jpg", alt: "" },
    { id: 2, src: "/carousel1/2.jpg", alt: "" },
    { id: 3, src: "/carousel1/3.jpg", alt: "" },
    { id: 4, src: "/carousel1/4.jpg", alt: "" },
    { id: 5, src: "/carousel1/5.jpg", alt: "" },
    { id: 6, src: "/carousel1/6.jpg", alt: "" },
    { id: 7, src: "/carousel1/7.jpg", alt: "" },
    { id: 8, src: "/carousel1/8.jpg", alt: "" },
    { id: 9, src: "/carousel1/9.jpg", alt: "" },
    { id: 10, src: "/carousel1/10.jpg", alt: "" },
    { id: 11, src: "/carousel1/11.jpg", alt: "" },
    { id: 12, src: "/carousel1/12.jpg", alt: "" },
    { id: 13, src: "/carousel1/13.jpg", alt: "" }
  ];

  const videos = [
  // {
  //   src: video1,
  //   description: "Description for Video 1"
  // },
  // {
  //   src: video2,
  //   description: "Description for Video 2"
  // },
  {
    src: video3,
    description: "📚 ஈரோடு புத்தகத் திருவிழா 2026 புத்தகங்கள் அறிவையும் சிந்தனையையும் வளர்க்கும் சக்தி கொண்டவை. இவ்வாண்டு நடைபெறும் ஈரோடு புத்தகத் திருவிழாவில் கலந்து கொண்டு பயனடைய அன்புடன் அழைக்கிறோம். ஜூலை 31 – ஆகஸ்ட் 11"
  },
  {
    src: video4,
    description: "எழுச்சிகரமான 22ஆம் ஆண்டில், ஈரோடு புத்தகத் திருவிழா 2026 நாள்: ஜூலை 31 முதல் ஆகஸ்ட் 11 வரை (12 நாட்கள்) இடம்: சிக்கய்ய அரசு கலை மற்றும் அறிவியல் கல்லூரி, ஈரோடு அரிதான வாய்ப்பை முழுமையாகப் பயன்படுத்த அனைவரும் வருகை புரிய அன்புடன் அழைக்கிறோம்."
  },
  {
    src: video5,
    description: "ஈரோடு புத்தகத் திருவிழா 2026, எழுச்சிகரமான 22ஆம் ஆண்டில்... நாள்: ஜூலை 31 முதல் ஆகஸ்ட் 11 வரை (12 நாட்கள்) இடம்: சிக்கய்ய அரசு கலை மற்றும் அறிவியல் கல்லூரி, ஈரோடு அரிதான வாய்ப்பை முழுமையாகப் பயன்படுத்த அனைவரும் வருகை புரிய அன்புடன் அழைக்கிறோம்."
  },
  {
    src: video6,
    description: "வாசிப்பின் சக்தி! | Sakthi's Inspiring Story | Erode Book Festival 2026 வாசிப்புப் பழக்கம் தனது வாழ்க்கையில் ஏற்படுத்திய மாற்றங்களை இந்தக் காணொளியில் பகிர்ந்து கொள்கிறார் Sakthi. ஈரோடு புத்தகத் திருவிழா என்பது புத்தகங்களை வாங்கும் இடம் மட்டுமல்ல; புதிய சிந்தனைகள், புதிய மனிதர்கள், புதிய வாய்ப்புகளை சந்திக்கும் ஒரு அறிவுத் திருவிழா. நீங்களும் இந்த ஆண்டு குடும்பத்துடன் கலந்து கொண்டு, உங்களுக்கான புத்தகத்தைத் தேர்ந்தெடுக்க வாருங்கள். 📖 ஈரோடு புத்தகத் திருவிழா 2026 🗓️ 31 ஜூலை – 11 ஆகஸ்ட் 2026📍 சிக்கய்ய அரசு கலை மற்றும் அறிவியல் கல்லூரி, ஈரோடு"
  },
  {
    src: video7,
    description: "ஈரோடு புத்தகத் திருவிழா 2026 ஆயிரக்கணக்கான புத்தகங்கள், புதிய சிந்தனைகள் மற்றும் அறிவார்ந்த அனுபவங்களுடன் நடைபெறும் ஈரோடு புத்தகத் திருவிழாவிற்கு குடும்பத்துடன் வருகை தாருங்கள். ஜூலை 31 – ஆகஸ்ட் 11📍 சிக்கய்ய அரசு கலை மற்றும் அறிவியல் கல்லூரி, ஈரோடு"
  },
  {
    src: video8,
    description: "இயக்குநர் கே. பாக்யராஜ் அவர்களின் வாசிப்பு குறித்த சிந்தனைகள்! புத்தகங்கள் வாழ்க்கையில் ஏற்படுத்தும் மாற்றங்கள் குறித்து அவர் பகிரும் சுவாரஸ்யமான கருத்துகளைக் காணுங்கள். ஈரோடு புத்தகத் திருவிழா 2026 புத்தகங்களும் சிந்தனைகளும் சங்கமிக்கும் இந்த அறிவுத் திருவிழாவில் குடும்பத்துடன் கலந்து கொள்ள வாருங்கள்! 🗓️ ஜூலை 31 - ஆகஸ்ட் 11 📍 சிக்கய்ய அரசு கலை மற்றும் அறிவியல் கல்லூரி, ஈரோடுDescription for Video 8"
  },
    {
    src: video9,
    description: "இயக்குநர் இமயம் பாரதிராஜா அவர்கள் ஈரோடு புத்தகத் திருவிழா 2026 குறித்து தனது சிறப்பான கருத்துகளையும் வாழ்த்துகளையும் பகிர்ந்து கொள்கிறார். வாசிப்பை நேசிக்கும் அனைவரும் தவறாமல் குடும்பத்துடன் கலந்து கொள்ள வேண்டிய அறிவுத் திருவிழா இது. ஆயிரக்கணக்கான புத்தகங்கள், சிறப்பு நிகழ்ச்சிகள் மற்றும் புதிய சிந்தனைகளுடன் உங்களை வரவேற்கிறது. 🗓️ ஜூலை 31 – ஆகஸ்ட் 11 📍 சிக்கய்ய அரசு கலை மற்றும் அறிவியல் கல்லூரி, ஈரோடு."
  },
  {
    src: video10,
    description: "பள்ளிக் கல்வித்துறை & மக்கள் சிந்தனைப் பேரவை இணைந்து நடத்தும்\nஈரோடு புத்தகத் திருவிழா 2026."
  }
];

  const openLightbox = (index) => setLightboxIndex(index);
  const closeLightbox = () => setLightboxIndex(null);

  const nextLightbox = useCallback(() => {
    setLightboxIndex((prev) =>
      prev === null ? null : (prev + 1) % carouselImages.length
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const prevLightbox = useCallback(() => {
    setLightboxIndex((prev) =>
      prev === null
        ? null
        : (prev - 1 + carouselImages.length) % carouselImages.length
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (lightboxIndex === null) return;
    const handleKey = (e) => {
      if (e.key === "ArrowRight") nextLightbox();
      if (e.key === "ArrowLeft") prevLightbox();
      if (e.key === "Escape") closeLightbox();
    };
    window.addEventListener("keydown", handleKey);
    return () => window.removeEventListener("keydown", handleKey);
  }, [lightboxIndex, nextLightbox, prevLightbox]);

const guests = [
  {
    date: "31.07.2026",
    day: "வெள்ளி",
    name: "நாடாளுமன்ற - சட்டமன்ற உறுப்பினர்கள், மேயர், துணை மேயர் மற்றும் அரசு அலுவலர்கள்\nதலைமை : மாவட்ட ஆட்சித் தலைவர்",
    topic: "தொடக்க விழா"
  },
  {
    date: "01.08.2026",
    day: "சனி",
    name: "தமிழருவி மணியன்",
    topic: "'காவியத்தாயின் இளைய மகன்'"
  },
  {
    date: "02.08.2026",
    day: "ஞாயிறு",
    name: "நீதிபதி என். ஆனந்த் வெங்கடேஷ்\nசென்னை உயர்நீதிமன்ற நீதிபதி",
    topic: "'மனிதப் பரிணாமமும் டிஜிட்டல் உலகின் சவாலும்'"
  },
  {
    date: "03.08.2026",
    day: "திங்கள்",
    name: "எழுத்தாளர் எஸ். ராமகிருஷ்ணன்",
    topic: "'காலமும் கனவுகளும்'"
  },
  {
    date: "04.08.2026",
    day: "செவ்வாய்",
    name: "கே. வைத்தியநாதன்\nஆசிரியர், தினமணி நாளிதழ்\n\nதிருப்பூர் கிருஷ்ணன்\nஆசிரியர், அமுதசுரபி மாத இதழ்",
    topic: "'கற்றவராலே உலகு காப்புற்றது'\n'இலக்கியம்... அன்றும் இன்றும்'"
  },
  {
    date: "05.08.2026",
    day: "புதன்",
    name: "சென்னை கலைக்குழு வழங்கும் 'மண்ணுயிர்க்கெல்லாம்'\n(மணிமேகலை காப்பியத்தை அடியொற்றிய தமிழ் நாடகம்)\n\nபனுவல் & நெறியாள்கை : பிரளயன்\n\nஉருபாணர் இசைக்குழுவின் 'யாழ் இசை நிகழ்வு'",
    topic: "நாடகம் - இசைநிகழ்ச்சி"
  },
  {
    date: "06.08.2026",
    day: "வியாழன்",
    name: "நீதிபதி இரா. சுரேஷ் குமார்\nசென்னை உயர்நீதிமன்ற மேனாள் நீதிபதி\n\nச. கார்த்திகைச்செல்வன்\nஆசிரியர், நியூஸ்18 தமிழ்நாடு",
    topic: "'எது முன்னேற்றம்?'\n'அறிவே அழகு... அதுவே அதிகாரம்!!'"
  },
  {
    date: "07.08.2026",
    day: "வெள்ளி",
    name: "பேராசிரியர் ஜெயந்தஸ்ரீ பாலகிருஷ்ணன்\n\nமுனைவர் வீ.ப. ஜெயசீலன், ஐஏஎஸ்\nஇயக்குநர், தமிழ்நாடு சுற்றுலாத்துறை மற்றும் தமிழ்நாடு தொல்லியல் துறை",
    topic: "'நாமுயர நாடுயரும்'\n'தொன்மையும் தொடர்ச்சியும்'\n'பிறப்பொக்கும் எல்லா உயிர்க்கும்'"
  },
  {
    date: "08.08.2026",
    day: "சனி",
    name: "வெ. கிருஷ்ணமூர்த்தி",
    topic: "'பிறப்பொக்கும் எல்லா உயிர்க்கும்'"
  },
  {
    date: "09.08.2026",
    day: "ஞாயிறு",
    name: "வெ. திருப்புகழ், ஐஏஎஸ் (ஓய்வு)\n\n(சிங்கப்பூர் சிறப்பு நாள் கருத்தரங்கம்)\n\nதலைமை: இரா. தினகரன் J.P.\nமேனாள் நியமன உறுப்பினர், நாடாளுமன்றம், சிங்கப்பூர்\n\nநா. ஆண்டியப்பன்\nமேனாள் தலைவர், சிங்கப்பூர் தமிழ் எழுத்தாளர் கழகம்\n\nகவிஞர் பிச்சினிக்காடு இளங்கோ\nநிறுவனர் - கவிமாலை\n\nஆசிரியர், மக்கள் மனம் மாத இதழ்\n\nமுனைவர் இரத்தின வேங்கடேசன்\nதலைவர், சிங்கப்பூர் தமிழ் இலக்கியக்களம்",
    topic: "'சிங்கப்பூர் ஓர் அதிசயம்'"
  },
  {
    date: "10.08.2026",
    day: "திங்கள்",
    name: "பேராசிரியர் இ. பாலகுருசாமி\nமேனாள் துணைவேந்தர், அண்ணா பல்கலைக்கழகம்\n\nஎழுத்தாளர் ஆயிஷா இரா. நடராசன்\nசாகித்ய அகாடமி விருதாளர்",
    topic: "'கடுகு சிறுத்தாலும்...'\n'அரியணையில் தமிழ்'\n\n'அறிவியல் மேதை ஜி.டி. நாயுடு விருது' வழங்கும் நிகழ்வு\n\n'இந்திய அறிவியலின் நம்பிக்கை நட்சத்திரங்கள்'"
  },
  {
    date: "11.08.2026",
    day: "செவ்வாய்",
    name: "விஞ்ஞானி மயில்சாமி அண்ணாதுரை\nமுன்னாள் இயக்குநர், ISRO\n\nதலைவர், தமிழ்நாடு அரசு பள்ளிக்கல்வி பாடத்திட்ட வடிவமைப்புக்குழு",
    topic: "நிறைவு விழா"
  }
];

  const slogans = [
    { number: "01", text: "இல்லந்தோறும் நூலகம்" },
    { number: "02", text: "நூலகமில்லா ஊரில் குடியிருக்க வேண்டாம்" },
    { number: "03", text: "நல்ல நூல்களே நல்ல நண்பர்கள்" }
  ];

  const objectives = [
    "வெறும் நூல் வணிகத்தை மட்டுமே அடிப்படையாகக் கொண்டு இப்புத்தகத் திருவிழா நடத்தப்படவில்லை. மாறாக... நல்ல நூல்களை நாட்டு மக்களுக்கு அறிமுகப்படுத்தும் உயர்ந்த நோக்கிலும், அவ்வாறு கிடைக்கப்பெறும் சிறந்த நூல்களை வாசிக்கத் தூண்டும் எண்ணத்திலும் இப்புத்தகத் திருவிழா நடத்தப்படுகிறது.",
    "சடங்கு பூர்வமாகவோ, சம்பரதாயத்திற்காகவோ நடத்தப்படாமல் முழுக்க முழுக்க சமுதாய நோக்கிலேயே இப்புத்தகத் திருவிழா நடத்தப்படுகிறது.",
    "தமிழர்களுக்கு விசாலமான உலகப்பார்வையை உருவாக்கும் பொருட்டு உலகு தழுவிய இலக்கியங்கள், அரசியல் கருத்துகள், விஞ்ஞானக் கண்டுபிடிப்புகள், வரலாற்றுச் செய்திகள், தொழில்நுட்ப விளக்கங்கள், வணிக அனுபவங்கள், தொழில் வளர்ச்சி ஆலோசனைகள், வேளாண்மை முயற்சிகள் போன்ற பன்முகத் தலைப்புக்களிலான மிகத் தரமான நூல்களை மக்கள் கரங்களில் தவழச் செய்வது.",
    "பட்டப்படிப்பு, பல்வேறு துறைசார்ந்த உயர்பட்டப் படிப்பு மற்றும் ஆராய்ச்சிப் படிப்பிற்குத் தேவையான, தேடினாலும் கிடைக்கப்பெறாத நூல்களை பல்வேறு தரமான வெளியீட்டாளர்களின் மூலம் இப்புத்தகத் திருவிழாவில் மாணவர்களுக்கு கிடைக்க ஏற்பாடு செய்வது.",
    "பள்ளி, கல்லூரிகளில் பயிலும் மாணவர்களுக்குப் பாடப் புத்தகங்கள் போக வேறு பொதுவான பயனுள்ள நூல்களை வாசிக்கும் பழக்கத்தை மேம்படுத்துவது. மதிப்பெண்கள் பெறுவது மட்டுமல்லாமல் மனித மதிப்புகளைக் கற்றுக் கொடுக்கும் நூல்களை வாசிக்கும் வழக்கத்தை மாணவர்கள் மத்தியில் அதிகரிப்பது.",
    "நம் நாடு பற்றிய கடந்த காலப் பெருமிதத்தையும், நிகழ்கால நிகழ்வுகள் குறித்த கவலையையும், எதிர்காலம் பற்றிய கனவுகளையும் இளைஞர்களின் நெஞ்சங்களில் உருவாக்குவது. எதிர்கால இந்தியா எப்படி இருக்க வேண்டும் என்பது குறித்த ஆழ்ந்த சிந்தனையை உருவாக்குவதோடு, அவ்வாறு கனவில் முகிழ்க்கும் மகிழ்ச்சி நிறைந்த இந்தியாவை நனவில் படைக்க இளைஞர்களையும், மாணவர்களையும் கடுமையாக உழைக்கும் பொருட்டு களமிறக்குவது.",
    "கொங்கு மண்டலத்திலுள்ள கல்வி நிலையங்களின் நூலகங்களுக்கு உரிய கழிவுகளுடன் நல்ல நூல்கள் கிடைக்க ஏற்பாடு செய்வது. பொது நூலகங்களில் நல்லுள்ளம் கொண்டவர்களின் உதவிகள் மூலம் ஏராளமான நல்ல நூல்கள் இடம்பெற முயற்சிகள் மேற்கொள்வது.",
    "படித்தவர்கள், பட்டம் பெற்றவர்கள், படைப்பாளிகள், மாணவர்கள், ஆசிரியர்கள் என்பதோடு மட்டுமல்லாமல் அவ்வளவாகக் கல்வியறிவில்லாத பாட்டாளி மக்களும் சாதாரண நிலையிலிருக்கும் சாமானியர்களும் கூட இப்புத்தகத் திருவிழாவை நன்கு பயன்படுத்தி, அவர்களும் நிறைய நூல்கள் வாசித்து உலக அறிவு பெற்றவர்களாக உயர இப்புத்தகத்திருவிழா மூலம் முயற்சிப்பது.",
    "புத்தகத் திருவிழாவில் தினம்தோறும் மாலைப்பொழுதில் நடைபெறும் இலக்கியக் கூட்டங்களில் பல்லாயிரம் பேரைப் பங்கேற்க வைத்து, அறிஞர்கள் கூறும் கருத்துக்களைக் கேட்பதன் மூலம் அவர்களுக்கு நூல்கள் குறித்த ஈடுபாட்டை ஏற்படுத்த முயற்சிப்பது."
  ];

  const videoSettings = {
  dots: true,
  infinite: true,
  speed: 500,
  slidesToShow: 1,
  slidesToScroll: 1,
  arrows: true,
  adaptiveHeight: true
};

  return (
    <div className="home-container">
      <div className={`main-content ${!isMobile ? "with-sidebar" : ""}`}>

        {/* ============ HERO — split screen ============ */}
        <div className="hero-section">
          <div className="hero-grid">
            <div className="hero-left">
              <div className="hero-grain"></div>
              <div className="hero-glow"></div>
              <Reveal as="div" className="hero-left-inner">
                <span className="hero-badge">
                  <FaBookOpen /> 22ஆம் ஆண்டு &nbsp;•&nbsp; 2026
                </span>
                <h1 className="hero-title">
                  ஈரோடு
                  <span className="hero-title2">புத்தகத் திருவிழா</span>
                </h1>
                <p className="hero-description">
                  2005 ஆம் ஆண்டு முதல் மக்கள் சிந்தனைப் பேரவையால் நடத்தப்படும்
                  ஈரோடு புத்தகத் திருவிழா ஒவ்வொரு ஆண்டும் மிகச் சிறப்பாக
                  நடைபெற்று வருகிறது.
                </p>
                <div className="hero-cta-row">
                  <a href="#guests" className="hero-cta primary">
                    விருந்தினர்களைக் காண
                  </a>
                  <a href="#gallery" className="hero-cta ghost">
                    நினைவுகள்
                  </a>
                </div>
              </Reveal>
            </div>

            <div className="hero-right">
              <div className="hero-video-frame">
                {!videoPlaying && (
                  <button
                    className="play-button-overlay"
                    onClick={handlePlayVideo}
                    aria-label="Play video"
                  >
                    <span className="play-button-icon">
                      <FaPlay />
                    </span>
                  </button>
                )}
                <video
                    autoPlay
                    muted
                    playsInline
                    controls
                    className="hero-video"
                >
                  <source src="https://media.mpdatahub.com/uploads/ERODE%20READS%202026.mp4" type="video/mp4" />
                </video>
              </div>
            </div>
          </div>

          {/* Floating info bar straddling the split */}
          <Reveal as="div" className="hero-infobar" delay={150}>
            <div className="infobar-item">
              <FaMapMarkerAlt className="infobar-icon" />
              <span>சிக்கய்ய அரசு கலை &amp; அறிவியல் கல்லூரி மைதானம், ஈரோடு</span>
            </div>
            <div className="infobar-divider" />
            <div className="infobar-item">
              <FaCalendarAlt className="infobar-icon" />
              <span>ஜூலை 31 முதல் ஆகஸ்ட் 11 </span>
            </div>
            <div className="infobar-divider" />
            <div className="infobar-item">
              <FaClock className="infobar-icon" />
              <span>காலை 11 – இரவு 9:30</span>
            </div>
            <div className="infobar-divider" />
            <div className="infobar-item">
              <FaMicrophone className="infobar-icon" />
              <span>தினமும் மாலை 6 மணிக்கு சொற்பொழிவு</span>
            </div>
          </Reveal>
        </div>

        {/* ============ SLOGANS — connected chain ============ */}
        <section className="slogans-section">
          <Reveal as="h3" className="slogans-heading">
            'மக்கள் சிந்தனைப் பேரவை' முன்வைக்கும் முப்பெரும் முழக்கங்கள்
          </Reveal>
          <div className="slogans-chain">
            {slogans.map((slogan, i) => (
              <Reveal
                key={slogan.number}
                delay={i * 150}
                className="slogan-node"
                as="div"
              >
                <div className="slogan-number">{slogan.number}</div>
                <div className="slogan-text">{slogan.text}</div>
              </Reveal>
            ))}
          </div>
        </section>

        {/* ============ OBJECTIVES — zig-zag magazine rows ============ */}
        <section className="objectives-section">
          <Reveal as="div" className="objectives-header-wrap">
            <span className="section-eyebrow">நோக்கம்</span>
            <h2 className="objectives-heading">
              புத்தகத் திருவிழாவின் நோக்கங்கள்
            </h2>
          </Reveal>

          <div className="objectives-rows">
            {objectives.map((text, index) => (
              <Reveal
                key={index}
                className={`objective-row ${
                  index % 2 === 1 ? "objective-row-reverse" : ""
                }`}
                as="div"
              >
                <div className="objective-ghost-num">
                  {String(index + 1).padStart(2, "0")}
                </div>
                <p className="objective-text">{text}</p>
              </Reveal>
            ))}
          </div>
        </section>

        {/* ============ GUESTS — vertical timeline ============ */}
        <section className="timeline-section" id="guests">
          <Reveal as="div" className="timeline-header">
            <span className="section-eyebrow">விருந்தினர்கள்</span>
            <h2 className="section-title">
              புத்தகத் திருவிழா 2026 - சிறப்பு விருந்தினர்
            </h2>
          </Reveal>
          <button
            onClick={() => window.open("/guest.pdf", "_blank")}
            className="download-btn"
          >
            Download PDF
          </button>

          <div className="timeline">
            <div className="timeline-spine" />
            {guests.map((guest, index) => (
              <Reveal
                key={index}
                delay={(index % 4) * 80}
                as="div"
                className={`timeline-item ${
                  index % 2 === 0 ? "timeline-left" : "timeline-right"
                }`}
              >
                <div className="timeline-dot">{index + 1}</div>
                <div className="timeline-card">
                  <div className="timeline-date">
                    {guest.date} <em>({guest.day})</em>
                  </div>
                  <div className="timeline-name">{guest.name}</div>
                  <div className="timeline-topic">{guest.topic}</div>
                </div>
              </Reveal>
            ))}
          </div>
        </section>

        {/* ============ GALLERY — bento grid + lightbox ============ */}
        <section className="gallery-section" id="gallery">
          <Reveal as="div" className="timeline-header">
            <span className="section-eyebrow">நினைவுகள்</span>
            <h2 className="section-title">புத்தகத் திருவிழா நினைவுகள்</h2>
          </Reveal>

          <div className="bento-grid">
            {carouselImages.map((image, index) => (
              <Reveal
                key={image.id}
                delay={(index % 6) * 60}
                as="button"
                className={`bento-tile ${
                  index === 0 ? "bento-tile-featured" : ""
                }`}
              >
                <span
                  className="bento-tile-inner"
                  onClick={() => openLightbox(index)}
                  role="button"
                  tabIndex={0}
                >
                  <img
                    src={image.src}
                    alt={image.alt}
                    loading="lazy"
                    className="bento-img"
                  />
                  <span className="bento-overlay">
                    <FaExpand />
                  </span>
                </span>
              </Reveal>
            ))}
          </div>
        </section>

        {/* ============ CLOSING — video + quote split ============ */}
<section className="closing-section">
  <Reveal as="div" className="closing-video-wrap">
   <Slider {...videoSettings}>
  {videos.map((video, index) => (
    <div key={index}>
      <div className="video-slide">
        <video controls className="closing-video" muted playsInline>
          <source src={video.src} type="video/mp4" />
          Your browser does not support the video tag.
        </video>

        <p className="video-description">
          {video.description}
        </p>
      </div>
    </div>
  ))}
</Slider>
  </Reveal>

  {/* <Reveal as="div" className="closing-quote-wrap" delay={150}>
    <FaQuoteLeft className="closing-quote-icon" />
    <p className="closing-quote-text">
      With the lyrics of Vairamuthu sir about our book festival, the miracle of
      the book and the reader unite the moment a reader enters a book.
    </p>
    <span className="closing-quote-sub">
      22nd Annual Erode Book Festival 2026 — conducted by Tamil Nadu Government
      &amp; People's Thought Council, Erode
    </span>
  </Reveal> */}
</section>

        {/* ============ LIGHTBOX MODAL ============ */}
        <ReactModal
          isOpen={lightboxIndex !== null}
          onRequestClose={closeLightbox}
          className="image-modalhm"
          overlayClassName="image-modal-overlayhm"
          ariaHideApp={false}
        >
          <button className="modal-closehm" onClick={closeLightbox} aria-label="Close">
            <FaTimes />
          </button>
          {lightboxIndex !== null && (
            <>
              <button
                className="modal-navhm modal-prevhm"
                onClick={prevLightbox}
                aria-label="Previous image"
              >
                <FaChevronLeft />
              </button>
              <img
                src={carouselImages[lightboxIndex].src}
                alt="Full screen"
                className="modal-imagehm"
              />
              <button
                className="modal-navhm modal-nexthm"
                onClick={nextLightbox}
                aria-label="Next image"
              >
                <FaChevronRight />
              </button>
              <div className="modal-counterhm">
                {lightboxIndex + 1} / {carouselImages.length}
              </div>
            </>
          )}
        </ReactModal>
      </div>
    </div>
  );
};

export default Home;